import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import FormButton from 'components/form-components/FormButton';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';

const CompanyFieldActions = ({ ids, actionsCallBack, isActionButton }) => {
  const [actionsOptions, setActionsOptions] = useState([]);

  useEffect(() => {
    const allOptions = [
      {
        value: 'delete',
        displayValue: 'select_hide',
        permission: ids.length === 1 && !ids[0].isDeleted,
      },
    ];

    const visibleOptions = allOptions.filter((option) => option.permission);

    setActionsOptions(visibleOptions);
  }, [ids.length]);

  const handleAction = (_, value) => {
    if (value === 'delete') actionsCallBack(value, { id: ids[0].id });
  };

  return (
    <>
      <MultiLevelSelect
        options={{ children: actionsOptions }}
        value={[]}
        name='action'
        handleChange={(name, value) => handleAction(name, value[0])}
        toggleClasses=''
        toggleComponent={
          <>
            {isActionButton ? (
              <img className='cursor-pointer' src={dotsIcon} />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} minWidth />
            )}
          </>
        }
        disabled={!ids.length || !actionsOptions.length}
      />
    </>
  );
};

CompanyFieldActions.propTypes = {
  ids: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  isActionButton: PropTypes.bool.isRequired,
};

export default CompanyFieldActions;
